module.exports = __webpack_public_path__ + "img/guide_lost_1.0d2d7882.png";